import { useState } from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  PinInput,
  PinInputField,
  Text,
  useColorModeValue,
  useToast,
  HStack
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useHistory } from "react-router-dom";
import { authApiAction } from "stores/redux/apiSlices/authApiSlice";
import { useDispatch } from "react-redux";
import { toastActions } from "stores/redux/slices/toastSlice";
import { localStore } from "stores/localStore";
import ResetPasswordInput from "./ResetPasswordInput";
import { clientsApiAction } from "stores/redux/apiSlices/clientApi/clientApiSlice";

function LoginInput() {
  const toast = useToast();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [resetMode, setResetMode] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpValue, setOtpValue] = useState("");

  const history = useHistory();
  const [handleLogin] = authApiAction.login();
  const [handleSendOtpApi] = authApiAction.sendOtp();
  const [verifyUserApi] = authApiAction.verifyUser();
  const [otpToken, setOtpToken] = useState(null);

  
  
  const dispatch = useDispatch();

  const titleColor = useColorModeValue("teal.300", "teal.200");
  const textColor = useColorModeValue("gray.400", "white");
    const [resetpassword, setResetPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [passwordErrors, setPasswordErrors] = useState({});
    const [resetPassword] = clientsApiAction.resetPasswordApi();
  
    const validatePassword = () => {
      let newErrors = {};
  
      if (!resetpassword) {
        newErrors.resetpassword = "Ο κωδικός είναι απαραίτητος.";
      } else if (resetpassword.length < 6) {
        newErrors.resetpassword = "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.";
      }
  
      if (!confirmPassword) {
        newErrors.confirmPassword = "Επιβεβαίωσε τον κωδικό σου.";
      } else if (confirmPassword !== resetpassword) {
        newErrors.confirmPassword = "Οι κωδικοί δεν ταιριάζουν.";
      }
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
    const handleResetPasswordSubmit = async () => {
      if (!validatePassword()) return;
    
      const resetPayload = {
        password: resetpassword,
        confirmPassword,
      };
    
      try {
        const response = await resetPassword(resetPayload).unwrap();
    
        if (response.success === true) {
          localStore.resetToken(); // Remove token
    
          toast({
            title: "Επιτυχής αλλαγή",
            description: "Ο κωδικός σου άλλαξε με επιτυχία.",
            status: "success",
            duration: 4000,
            isClosable: true,
          });
    
          // 👇 Redirect to login after successful reset
          history.push("/login"); 
        }
    
        // redirect or reset state if needed
      } catch (error) {
        toast({
          title: "Αποτυχία",
          description: error?.data?.message || "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      }
    };
    

  const validate = () => {
    let newErrors = {};
    if (!email) {
      newErrors.email = "Το email είναι απαραίτητο.";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
      newErrors.email = "Μη έγκυρη διεύθυνση email.";
    }

    if (!resetMode) {
      if (!password) {
        newErrors.password = "Ο κωδικός είναι απαραίτητος.";
      } else if (password.length < 6) {
        newErrors.password = "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    const payload = { email, password,request_type:"WEB" };
    handleLogin(payload)
      .unwrap()
      .then((response) => {
        if (response) {
          dispatch(
            toastActions.setToastData({
              message: response.message,
              variant: "error"
            })
          );
          toast({
            title: "Success",
            description: response.message || "Οδηγός δημιουργήθηκε με επιτυχία",
            status: "success",
            duration: 4000,
            isClosable: true
          });

          if (response.success) {
            localStore.setToken(response.data.token);
            history.push("/admin/lista_paraggelion");
          }
        }
      })
      .catch((error) => {
        toast({
          title: "Error",
          description: error.data?.message || "Αποτυχία δημιουργίας οδηγού",
          status: "error",
          duration: 4000,
          isClosable: true
        });
      });
  };

const handleResetPassword = async () => {
  if (!validate()) return;

  try {
    await handleSendOtpApi({ email }).unwrap();
    setOtpSent(true);
    toast({
      title: "OTP Sent",
      description: "Το OTP στάλθηκε στο email σας.",
      status: "info",
      duration: 3000,
      isClosable: true,
    });
  } catch (error) {
    toast({
      title: "Σφάλμα",
      description: error?.data?.message || "Αποτυχία αποστολής OTP.",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  }
};


const handleOtpSubmit = async () => {
  if (otpValue.length !== 6) {
    toast({
      title: "Σφάλμα OTP",
      description: "Το OTP πρέπει να έχει 6 ψηφία.",
      status: "error",
      duration: 3000,
      isClosable: true
    });
    return;
  }

  try {
    const payload = {
      email,
      otp: otpValue
    };

    const response = await verifyUserApi(payload).unwrap();

    if (response.success) {
      setOtpToken(response.data.token); // Save the token for reset password
      localStore.setToken(response.data.token);
      console.log(setOtpToken,"setOtpToken")
      setOtpVerified(true);
      toast({
        title: "OTP verified",
        description: response.message || "Μπορείτε τώρα να επαναφέρετε τον κωδικό σας.",
        status: "success",
        duration: 3000,
        isClosable: true
      });
    }
     else {
      toast({
        title: "Αποτυχία επαλήθευσης",
        description: response.message || "Το OTP δεν ήταν σωστό.",
        status: "error",
        duration: 3000,
        isClosable: true
      });
    }
  } catch (error) {
    toast({
      title: "Σφάλμα",
      description: error?.data?.message || "Η επαλήθευση απέτυχε. Δοκιμάστε ξανά.",
      status: "error",
      duration: 3000,
      isClosable: true
    });
  }
};


  // 👉 RENDER ONLY ResetPasswordInput when OTP is verified
  if (resetMode && otpVerified) {
    return (
      < >
        <ResetPasswordInput
          password={resetpassword}
          confirmPassword={confirmPassword}
          setPassword={setResetPassword}
          setConfirmPassword={setConfirmPassword}
          errors={errors}
          onSubmit={handleResetPasswordSubmit}
        />
      </>
    );
  }

  return (
    <Flex position="relative" mb="40px" justifyContent="center">
      <Flex
        direction="column"
        w={{ base: "100%", md: "50%", lg: "42%" }}
        background="transparent"
        p="48px"
        mt={{ md: "100px", lg: "80px" }}
      >
        <Heading color={titleColor} fontSize="32px" mb="10px">
          {resetMode ? "Επαναφορά Κωδικού" : "Καλώς ήρθατε"}
        </Heading>
        <Text mb="36px" ms="4px" color={textColor} fontWeight="bold" fontSize="14px">
          {resetMode
            ? "Εισάγετε το email σας για επαναφορά κωδικού"
            : "Εισάγετε το email και τον κωδικό σας για σύνδεση"}
        </Text>

        <FormControl isInvalid={errors.email}>
          <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
            Email
          </FormLabel>
          <Input
            borderRadius="15px"
            mb="24px"
            fontSize="sm"
            type="email"
            placeholder="διεύθυνση email"
            size="lg"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {errors.email && <Text color="red.500">{errors.email}</Text>}
        </FormControl>

        {!resetMode && (
          <FormControl isInvalid={errors.password}>
            <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
              Κωδικός
            </FormLabel>
            <InputGroup>
              <Input
                borderRadius="15px"
                mb="36px"
                fontSize="sm"
                type={showPassword ? "text" : "password"}
                placeholder="Γράψε τον κωδικό σου"
                size="lg"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                bg="blue.50"
              />
              <InputRightElement
                height="55%"
                pr="3"
                cursor="pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                <Icon as={showPassword ? ViewIcon : ViewOffIcon} w={5} h={5} color="gray.500" />
              </InputRightElement>
            </InputGroup>
            {errors.password && <Text color="red.500">{errors.password}</Text>}
          </FormControl>
        )}

        {resetMode ? (
          <>
            {!otpSent ? (
              <Button
                fontSize="sm"
                bg="teal.300"
                w="100%"
                h="45"
                color="white"
                mt="20px"
                onClick={handleResetPassword}
              >
                Υποβολή
              </Button>
            ) : (
              <>
                <Text mb={2} fontSize="sm">
                  Εισάγετε τον 6ψήφιο κωδικό OTP
                </Text>
                <HStack justify="center" mb={4}>
                  <PinInput otp onChange={(value) => setOtpValue(value)}>
                    {[...Array(6)].map((_, i) => (
                      <PinInputField key={i} />
                    ))}
                  </PinInput>
                </HStack>
                <Button colorScheme="teal" w="100%" onClick={handleOtpSubmit}>
                  Επαλήθευση OTP
                </Button>
              </>
            )}
          </>
        ) : (
          <Button
            fontSize="sm"
            bg="teal.300"
            w="100%"
            h="45"
            color="white"
            mt="20px"
            onClick={handleSubmit}
            isLoading={loading}
            _hover={{ bg: "teal.200" }}
            _active={{ bg: "teal.400" }}
          >
            Σύνδεση
          </Button>
        )}

        {!resetMode && (
          <Flex flexDirection="column" justifyContent="center" alignItems="center" mt="20px">
            <Text color={textColor} fontWeight="medium">
              Ξεχάσατε τον κωδικό σας;
              <Link
                color={titleColor}
                as="span"
                ms="5px"
                fontWeight="bold"
                cursor="pointer"
                onClick={() => setResetMode(true)}
              >
                Κάντε κλικ εδώ
              </Link>
            </Text>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
}

export default LoginInput;
